<template>
  <footer class="relative w-full h-full bg-[#01001D] px-4 py-12">
    <!-- MOBILE & TABLET Layout -->
    <div class="block xl:hidden max-w-[1400px] mx-auto px-4 sm:px-6 md:px-10">
      <!-- Logo -->
      <div class="flex justify-center mb-6">
        <img src="@/assets/cleanswipe-logo.png" class="w-[40px] h-auto" alt="logo" />
      </div>

      <!-- Nav Links -->
      <div class="flex justify-center flex-wrap gap-6 text-white text-base font-bold font-lato tracking-wide mb-6">
        <a
          v-for="item in navItems"
          :key="item.id"
          :href="`#${item.id}`"
          @click="navClick(item.id)"
          :class="{
            'text-[#1BF3FF]': activeSection === item.id,
            'hover:text-[#e4dfdf]': activeSection !== item.id,
          }"
          class="uppercase"
        >
          {{ item.name }}
        </a>
      </div>

      <!-- Help Text -->
      <p class="text-sm text-white text-center mb-4">
        If you ever feel that gambling is becoming a problem. Most people gamble for fun and enjoyment.
        However, some people think of gambling as a way to make money, spend more than they can afford,
        or use gambling to distract themselves from everyday problems.
      </p>
      <p class="text-[#1BF3FF] font-bold font-oxanium text-sm text-center mb-6">
        To find further advice, help and support visit: <br />
        <a href="https://www.begambleaware.org/" class="underline" target="_blank">
          https://www.begambleaware.org/
        </a>
      </p>

      <!-- Disclaimer -->
      <p class="text-sm text-white text-center leading-relaxed mb-6">
        We do not take responsibility for misunderstood promotions, losses from gambling in casinos or betting
        on sites which are linked to or promoted on this website. <br />
        Make sure it is legal for you to use each site inside your jurisdiction and ALWAYS gamble responsibly!
      </p>

      <!-- Bottom Bar -->
      <div class="flex flex-col items-center gap-3 text-center text-white text-xs font-bold font-oxanium">
        <div>CLEANSWIPE {{ currentYear }} © All rights reserved.</div>
        <div class="flex gap-3 mt-2">
          <a href="https://x.com/Cleanswipez" target="_blank"><img src="@/assets/twitter-footer.png" class="h-[20px]" /></a>
          <a href="https://www.youtube.com/@Cleanswipez" target="_blank"><img src="@/assets/youtube-footer.png" class="h-[24px]" /></a>
          <a href="https://kick.com/cleanswipe" target="_blank"><img src="@/assets/kick-footer.png" class="h-[20px]" /></a>
        </div>
      </div>
    </div>

    <!-- XL DESKTOP Layout -->
    <div class="hidden xl:flex max-w-[1400px] mx-auto px-16 gap-20 justify-between">
      <!-- Left Column -->
      <div class="flex flex-col gap-6 text-white font-lato w-1/2 text-left text-sm">
        <img src="@/assets/cleanswipe-logo.png" class="w-[40px] h-auto" alt="logo" />
        <p>
          If you ever feel that gambling is becoming a problem. Most people gamble for fun and enjoyment.
          However, some people think of gambling as a way to make money, spend more than they can afford,
          or use gambling to distract themselves from everyday problems.
        </p>
        <p class="text-[#1BF3FF] font-bold font-oxanium leading-snug text-sm">
          To find further advice, help and support visit: <br />
          <a href="https://www.begambleaware.org/" class="underline" target="_blank">
            https://www.begambleaware.org/
          </a>
        </p>
        <div class="text-xs font-bold font-oxanium mt-4">CLEANSWIPE {{ currentYear }} © All rights reserved.</div>
      </div>

      <!-- Right Column -->
      <div class="flex flex-col gap-6 text-white font-lato w-1/2 text-right text-sm justify-start mt-2 items-end">
        <div class="flex justify-center xl:justify-center gap-6 text-base font-bold tracking-wide">
          <a
            v-for="item in navItems"
            :key="item.id"
            :href="`#${item.id}`"
            @click="navClick(item.id)"
            :class="{
              'text-[#1BF3FF]': activeSection === item.id,
              'hover:text-[#e4dfdf]': activeSection !== item.id,
            }"
            class="uppercase"
          >
            {{ item.name }}
          </a>
        </div>

        <p class="mt-4">
          We do not take responsibility for misunderstood promotions, losses from gambling in casinos or betting
          on sites which are linked to or promoted on this website. <br />
          Make sure it is legal for you to use each site inside your jurisdiction and ALWAYS gamble responsibly!
        </p>

        <div class="flex justify-end gap-3 ">
          <a href="https://x.com/Cleanswipez" target="_blank"><img src="@/assets/twitter-footer.png" class="h-[20px]" /></a>
          <a href="https://www.youtube.com/@Cleanswipez" target="_blank"><img src="@/assets/youtube-footer.png" class="h-[24px]" /></a>
          <a href="https://kick.com/cleanswipe" target="_blank"><img src="@/assets/kick-footer.png" class="h-[20px]" /></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterElement",
  emits: ["navigate"],
  props: {
    activeSection: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      navItems: [
        { id: "home", name: "Home" },
        { id: "socials", name: "Socials" },
        { id: "promotions", name: "Promotions" },
        { id: "leaderboards", name: "Leaderboards" },
      ],
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    navClick(id) {
      this.$emit("navigate", id);
    },
  },
};
</script>t>
